import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { env } from '@sib/config';
import { useTranslation } from '@sib/i18n';
import type { SidebarMenuItem as BaseSidebarMenuItem } from '@sib/ui';
import {
  Audits,
  Customize,
  Dashboard,
  TeamOrg,
  Project,
  Vendors,
  Work,
  Revenue,
} from '@sib/ui/icons';
import { paths } from '@sidecar/config/paths';

export interface SidebarMenuItem extends BaseSidebarMenuItem {
  onItemClick?: (hasSubmenu: boolean) => void;
}

export const useSidebarItems = (): SidebarMenuItem[] => {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return useMemo(
    () =>
      [
        {
          href: paths.dashboard.root,
          title: t('sidebar.dashboard'),
          icon: Dashboard,
        },
        {
          href: paths.work.root,
          title: t('sidebar.work'),
          icon: Work,
        },
        {
          href: paths.organizations.root,
          title: t('sidebar.organizations'),
          icon: TeamOrg,
        },
        {
          href: paths.audits.root,
          title: t('sidebar.audits'),
          icon: Audits,
        },
        {
          href: paths.vendors.root,
          title: t('sidebar.vendors'),
          icon: Vendors,
        },
        {
          // TODO: add proper behaviour on expand/collapse
          href: pathname.startsWith(paths.projects.root)
            ? '#'
            : paths.projects.root,
          title: t('sidebar.projects'),
          icon: Project,
          hasExpandSubmenuArrow: true,
        },
        {
          href: paths.revenue.root,
          title: t('sidebar.revenue'),
          icon: Revenue,
        },
        ...(env.storybookEnabled
          ? [
              {
                href: paths.storybook,
                title: t('sidebar.storybook'),
                icon: Customize,
              },
            ]
          : []),
      ] satisfies SidebarMenuItem[],
    [t, pathname]
  );
};
